export const isLogin = () => {
    return{
        type:'LOGIN'
    }
}

export const logOut = () => {
    return{
        type:'LOGOUT'
    }
}

export const darkMode = () => {
    return{
        type:'dark'
    }
}

export const lightMode = () => {
    return{
        type:'light'
    }
}

export const adduser = (user) => {
    return{
        type:'ADDUSER',
        payload:user
    }
}

export const edituser = (user) => {
    return{
        type:'EDITUSER',
        payload:user
    }
}

export const deleteuser = () => {
    return{
        type:'DELETEUSER'
    }
}

export const saveToken = (token) => {
    return{
        type:'SAVETOKEN',
        payload:token
    }
}

export const removeToken = () => {
    return{
        type:'REMOVETOKEN'
    }
}

export const addTransac = (transac) => {
    return{
        type:'ADDTRANSAC',
        payload:transac
    }
}